'use client';

import { useState } from 'react';

import { CallOffOrderColor } from '@ravago/shared/page-data/models/elements';
import { Box } from '@ravago/shared/radiance/components/box/components/Box/Box';
import { Button } from '@ravago/shared/radiance/components/button/components/Button/Button';
import { Typography } from '@ravago/shared/radiance/components/typography/components/Typography/Typography';
import { useTranslations } from '@ravago/shared/translations/client';

import { CallOffGroup } from '../../utils/order-now-utils';
import { DynamicProductBlockCallOffFields } from '../order-now/dynamic-product-block-call-off-fields';

import { SelectedColorHeader } from './selected-color-header';

interface Props {
   selectedCallOffGroup: CallOffGroup;
   usesAgreementApp: boolean;
   callOffAgreementRoute?: string;
   hasMultipleSelections: boolean;
   onEdit: () => void;
   onContinueCallOff: (callOffOrderColor: CallOffOrderColor, quantity: number) => void;
}

export const CallOffDetailView = ({
   selectedCallOffGroup,
   usesAgreementApp,
   callOffAgreementRoute,
   hasMultipleSelections,
   onEdit,
   onContinueCallOff
}: Props) => {
   const translate = useTranslations();
   const [quantityAmount, setQuantityAmount] = useState<number | undefined>();

   const handleContinue = () => {
      if (!quantityAmount) return;
      onContinueCallOff(selectedCallOffGroup.callOffOrderColor, quantityAmount);
   };

   return (
      <Box direction="column">
         <Box direction="column" gap="md">
            <Typography variant="body-highlight" color="subtle">
               {translate('page-consumer.call-off-agreement-flyout.call-off-agreement')}{' '}
               {selectedCallOffGroup.callOffOrderColor.recommendedCallOff.id}
            </Typography>
            <SelectedColorHeader
               colorName={selectedCallOffGroup.colorName}
               producerColorCode={selectedCallOffGroup.producerColorCode}
               hasMultipleSelections={hasMultipleSelections}
               onEdit={onEdit}
            />
         </Box>
         <DynamicProductBlockCallOffFields
            id="call-off-detail-view"
            quantityAmount={quantityAmount}
            callOffOrderColor={selectedCallOffGroup.callOffOrderColor}
            usesAgreementApp={usesAgreementApp}
            callOffAgreementRoute={callOffAgreementRoute}
            onQuantityAmountChanged={setQuantityAmount}
         />
         <Button
            attributes={{ testid: 'call-off-button__continue' }}
            fullWidth
            trailingIcon="long-arrow-right"
            disabled={!quantityAmount}
            onClick={handleContinue}
         >
            {translate('request-for-quotation.continue')}
         </Button>
      </Box>
   );
};
